import React from 'react';
import { useDispatch } from 'react-redux';
import ProjectApiGateway from './ProjectApiGateway';
import { fetchProjects } from 'store/slices/project';

/**
 * API Gateway Module Page
 * Wrapper component for API Gateway management
 * Route: /workspace/storage/:projectId/api-gateway
 */
const ApiGatewayModulePage = ({ projectName, projectSubname, onBack }) => {
    const dispatch = useDispatch();
    const userToken = localStorage.getItem('user_token');

    const handleClose = () => {
        dispatch(fetchProjects());
        onBack();
    };

    return <ProjectApiGateway projectName={projectName} projectSubname={projectSubname} userToken={userToken} onClose={handleClose} />;
};

export default ApiGatewayModulePage;
